export enum IChangeType {
  Added,
  Modified,
  Removed,
  Moved,
}

export interface IComponentChange {
  // Number of the component on the position's drawing (the new one, or the old one when removed).
  slot: number
  productNumber?: string
  description?: string
  // Set when the slot now holds a different product.
  previousProductNumber?: string
  previousDescription?: string
  type: IChangeType
  quantityBefore: number
  quantityAfter: number
  unitPriceBefore?: number
  unitPriceAfter?: number
  // Name of the product's category, when it has one.
  category?: string
}

export interface IFieldChange {
  // Key such as "depth"; translated as change-field-<key>.
  field: string
  before?: string
  after?: string
}

export interface IWorkChange {
  productNumber?: string
  description?: string
  quantity: number
  type: IChangeType
  // Customer price excl. VAT; missing when the price service did not answer.
  unitPrice?: number
}

export interface IPositionMove {
  meters: number
  // Degrees clockwise from north.
  bearing: number
}

export interface IPositionChange {
  name: string
  // The name in the published version, when the revision renamed the position.
  previousName?: string
  type: IChangeType
  // Every way the position changed; Modified covers drawing, components and other fields, Moved the coordinates.
  kinds: IChangeType[]
  move?: IPositionMove
  fields: IFieldChange[]
  components: IComponentChange[]
  work: IWorkChange[]
}

export interface IProjectVersionChanges {
  baseProjectId: number
  baseVersionNumber: number
  versionNumber: number
  positions: IPositionChange[]
}
